export interface AccountProfile {
  id: string
  username: string
  displayName: string
  signupPlatform?: 'android' | 'windows' | 'web' | 'unknown'
  signupAppVersion?: string
}

export interface AccountSession {
  profile: AccountProfile
  token: string
  remember: boolean
}

const localSessionKey = 'card-vault-account-session'
const sessionSessionKey = 'card-vault-account-session-temporary'

export function saveAccountSession(session: AccountSession): AccountSession {
  const serialized = JSON.stringify(session)

  if (session.remember) {
    window.sessionStorage.removeItem(sessionSessionKey)
    window.localStorage.setItem(localSessionKey, serialized)
    return session
  }

  window.localStorage.removeItem(localSessionKey)
  window.sessionStorage.setItem(sessionSessionKey, serialized)
  return session
}

export function readAccountSession(): AccountSession | null {
  const storedSessions: Array<string | null> = []
  for (const readStoredSession of [
    () => window.localStorage.getItem(localSessionKey),
    () => window.sessionStorage.getItem(sessionSessionKey),
  ]) {
    try {
      storedSessions.push(readStoredSession())
    } catch {
      storedSessions.push(null)
    }
  }

  for (const raw of storedSessions) {
    try {
      if (!raw) {
        continue
      }
      const parsed = JSON.parse(raw) as AccountSession
      if (parsed?.token && parsed.profile?.id) {
        return parsed
      }
    } catch {
      // Try the other storage location.
    }
  }
  return null
}

export function clearAccountSession() {
  window.localStorage.removeItem(localSessionKey)
  window.sessionStorage.removeItem(sessionSessionKey)
}

export const accountSessionStorageKeys = {
  localSessionKey,
  sessionSessionKey,
}
